<template>
  <div style="height: 100%; width: 100%">
    <div
      class="google-map"
      ref="googleMap"
      style="height: 100%; width: 100%"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>
<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import { mapState } from 'vuex';

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
  },

  data() {
    return {
      google: null,
      map: null,
    };
  },
  computed: {
    ...mapState({
      nuevaPosicion: state => state.navegacionSig.posicion
    })
  },
  watch: {
    nuevaPosicion: 'cambiarPosicion'
  },

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey,

      libraries: ["drawing"],
    });
    this.google = googleMapApi;

    this.initializeMap();
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;

      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    },
    cambiarPosicion() {
      if (this.nuevaPosicion) {
        this.map.setCenter(this.nuevaPosicion);
        this.$store.commit("navegacionSig/actualizarPosicion", null);
      }
    }
  },
};
</script>
